/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import Platform from './platform';

// TODO Mohlo by se odstranit opakování napříč různými prostředími (multi-platformní kód).
// - /util.js parsePlatform.
// - Budou asi hlavně problémy s importy.
/**
 * Utility pro práci s číselníkem platforem.
 */
class PlatformUtil {
  /**
   * Vygeneruje textovou reprezentaci platformy.
   * @param {Platform|null} value Platforma z číselníku.
   * @returns {string|null} Platforma jako text.
   * @static
   */
  static generate(value) {
    switch (value) {
      case Platform.KiwiLighter1:
        return 'kiwi-lighter-1';
      case Platform.TizenSssp4:
        return 'tizen-sssp-4';
      case Platform.TizenSssp5:
        return 'tizen-sssp-5';
      case Platform.TizenSssp6:
        return 'tizen-sssp-6';
      case Platform.Web:
        return 'web';
      case Platform.WebosSignage3_0:
        return 'webos-signage-3.0';
      case Platform.WebosSignage3_2:
        return 'webos-signage-3.2';
      case Platform.WebosSignage4_0:
        return 'webos-signage-4.0';
      case Platform.WebosSignage4_1:
        return 'webos-signage-4.1';
      default:
        return null;
    }
  }

  /**
   * Načte platformu z textového řetězce.
   * @param {string|null} value Platforma jako text.
   * @returns {Platform|null} Platforma z číselníku.
   * @static
   */
  static parse(value) {
    switch (value) {
      case 'kiwi-lighter-1':
        return Platform.KiwiLighter1;
      case 'tizen-sssp-4':
        return Platform.TizenSssp4;
      case 'tizen-sssp-5':
        return Platform.TizenSssp5;
      case 'tizen-sssp-6':
        return Platform.TizenSssp6;
      case 'web':
        return Platform.Web;
      case 'webos-signage-3.0':
        return Platform.WebosSignage3_0;
      case 'webos-signage-3.2':
        return Platform.WebosSignage3_2;
      case 'webos-signage-4.0':
        return Platform.WebosSignage4_0;
      case 'webos-signage-4.1':
        return Platform.WebosSignage4_1;
      default:
        return null;
    }
  }
}

export default PlatformUtil;
